import app from "flarum/forum/app";
import LoadingIndicator from "flarum/common/components/LoadingIndicator";
import Placeholder from "flarum/common/components/Placeholder";
import ServerStatisticsPage from "./ServerStatisticsPage";

export default class ServerStatisticsDataPage extends ServerStatisticsPage {
  loading = false;
  data: any | null = null;

  statUrl() {
    return "https://rhd-api.tenmahw.com/zs/server/stat";
  }

  statName(key: string) {
    return app.translator.trans("rhodes-island.forum.zs_data." + key)
  }

  oncreate(vnode: any) {
    super.oncreate(vnode);

    this.refresh();
  }

  content() {
    if (this.loading) {
      return <LoadingIndicator/>;
    }

    if (this.data) {
      return <div className="stats">
        {
          Object.keys(this.data).map((key) => <div className="stat">
            <span className="server-statistics-title">{this.statName(key)}</span>
            <div className="stat-num">{new Intl.NumberFormat("en-US").format(this.data[key])}</div>
          </div>)
        }
      </div>
    } else {
      return <Placeholder text={app.translator.trans("rhodes-island.forum.statistics.not_available")}/>
    }
  }


  refresh() {
    this.loading = true;
    this.data = null;
    m.redraw();
    m.request({
      url: this.statUrl()
    }).then((data: any) => {
      if (data.success) {
        this.data = data.statistics;
        delete this.data.online_time;
      }
    }).finally(() => {
      this.loading = false;
      m.redraw();
    });
  }
}
